import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { GamesList } from '../../components/GamesList';
import { Game, GameLevel, GameModality, ParticipationStatus, ParticipantRole, CreateGameData } from '../../types/game';
import { gameService, GameStatus } from '../../services/gameService';
import { X } from 'lucide-react';
import { toastManager } from '../../lib/toastManager';
import { shareGame } from '../../utils/shareUtils';

export default function GamesPage() {
  const navigate = useNavigate();

  const handleGameClick = (gameId: string) => {
    // Navegar para a página de detalhes usando React Router
    navigate(`/app/games/${gameId}`);
  };

  const handleJoinGame = async (gameId: string) => {
    try {
      // TODO: Implementar quando tiver endpoint de join
      toastManager.success('🎯 Solicitação de participação enviada!');
    } catch (error) {
      console.error('Erro ao participar do jogo:', error);
    }
  };

  const handleCreateGame = async (gameData: CreateGameData) => {
    try {
      console.log('🎯 Creating game:', gameData);
      const newGame = await gameService.createGame(gameData);
      toastManager.success('🎉 Jogo criado com sucesso!');
      return newGame;
    } catch (error) {
      console.error('❌ Error creating game:', error);
      const errorMessage = error instanceof Error ? error.message : 'Erro ao criar jogo';
      toastManager.error(errorMessage);
      throw error;
    }
  };

  const handleSuccess = (message: string) => {
    toastManager.success(message);
  };

  const handleError = (message: string) => {
    toastManager.error(message);
  };

  return (
    <div className="p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <GamesList 
          onGameClick={handleGameClick}
          onJoinGame={handleJoinGame}
          onShare={shareGame}
          onCreateGame={handleCreateGame}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      </motion.div>
    </div>
  );
}